// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isObject(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
}
//# sourceMappingURL=isObject.js.map